/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountBalancesInput
 */
export interface AccountBalancesInput {
    /**
     * Date in UTC Seconds
     * Leave empty if you wish to use payment account IDs instead
     * @type {string}
     * @memberof AccountBalancesInput
     */
    updateDate?: string;
    /**
     * First payment account internal ID, starting from 12
     * @type {number}
     * @memberof AccountBalancesInput
     */
    internalAccountIdStart?: number;
    /**
     * Last payment account internal ID, starting from 12
     * @type {number}
     * @memberof AccountBalancesInput
     */
    internalAccountIdEnd?: number;
}

/**
 * Check if a given object implements the AccountBalancesInput interface.
 */
export function instanceOfAccountBalancesInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountBalancesInputFromJSON(json: any): AccountBalancesInput {
    return AccountBalancesInputFromJSONTyped(json, false);
}

export function AccountBalancesInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountBalancesInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateDate': !exists(json, 'updateDate') ? undefined : json['updateDate'],
        'internalAccountIdStart': !exists(json, 'internalAccountIdStart') ? undefined : json['internalAccountIdStart'],
        'internalAccountIdEnd': !exists(json, 'internalAccountIdEnd') ? undefined : json['internalAccountIdEnd'],
    };
}

export function AccountBalancesInputToJSON(value?: AccountBalancesInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateDate': value.updateDate,
        'internalAccountIdStart': value.internalAccountIdStart,
        'internalAccountIdEnd': value.internalAccountIdEnd,
    };
}

